import * as React from 'react';

import {FeatureStatusCard} from 'shells/card/feature-status-card';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {LoadingText} from 'shells/loading-placeholder/loading-text';
import {SectionLabel} from 'shells/typography/section-label';

import {appHistory} from '../../../history';

import {FEATURE_CONFIG} from './consts';

export function TrackingSnippetFeaturesLoadingState() {
    return (
        <StackLegacy spacing={12}>
            {Object.keys(FEATURE_CONFIG).map((key) => {
                return (
                    <React.Fragment key={key}>
                        {key === 'chat' && (
                            <div className='pt-16 pb-8'>
                                <SectionLabel noBottomBorder={true} noBottomMargin={true}>
                                    ENGAGEMENT
                                </SectionLabel>
                            </div>
                        )}
                        <FeatureStatusCard
                            onClick={() => {
                                // @ts-expect-error
                                appHistory.push(FEATURE_CONFIG[key].htmlPath);
                            }}
                            // @ts-expect-error
                            icon={FEATURE_CONFIG[key].icon}
                            // @ts-expect-error
                            title={FEATURE_CONFIG[key].title}
                            // @ts-expect-error
                            subtitle={FEATURE_CONFIG[key].description}
                            tertiaryData={<LoadingText width={200} height={12} />}
                            statusBadge={null}
                        />
                    </React.Fragment>
                );
            })}
        </StackLegacy>
    );
}
